import {SEARCH_QUERY} from '../../../constants/searchQuery';

export const getReferralCode = locationSearch => new URLSearchParams(locationSearch).get(SEARCH_QUERY.REFERRAL_CODE);
